import React from 'react';

import { replaceAll } from '../../../../../mol_function';

import { ProductDetailsPageProps } from '../../components/Model/ProductDetailsPageProps';

interface JSONLD_PDProps {
  body: ProductDetailsPageProps;
}
export default class JSONLD_PD extends React.Component<JSONLD_PDProps> {
  getValueFromAttribute(AttrName: string) {
    let atrTable = this.props.body.attribute;
    for (let i = 0; i < atrTable.length; i++) {
      if (atrTable[i].name == AttrName) return atrTable[i].value;
    }
    return null;
  }

  injectAtributeValue(
    item: any,
    itemName: string,
    attrName: string,
    converter?: (input: string) => string,
  ) {
    let value = this.getValueFromAttribute(attrName);
    if (value != null && converter != null) {
      value = converter(value);
    }
    if (value != null) item[itemName] = value;
  }

  injectImages(item: any) {
    let imagesHost = 'https://media.moluna.de/images/bilder/';
    if (this.props.body.images.length > 0) {
      item['image'] = [];
      for (let i = 0; i < this.props.body.images.length; i++) {
        item['image'].push(imagesHost + this.props.body.images[i]);
      }
    }
  }

  render() {
    let data = {
      '@context': 'http://schema.org/',
      '@type': 'Product',
      category: this.props.body.categorie,
      productID: this.props.body.productsId,
      sku: this.props.body.productsId,
      offers: {
        '@type': 'Offer',
        itemOffered: 'Product',
        itemCondition: 'neu',
        priceCurrency: 'EUR',
        price: this.replaceComa_Punkt(
          this.props.body.productPrice.substring(
            0,
            this.props.body.productPrice.length - 2,
          ),
        ),
        offeredBy: {
          '@type': 'Organization',
          address: 'Moluna GmbH, Engberdingdamm 27, 48268 Greven, Germany',
          brand: 'Moluna',
          email: 'service@moluna.de',
          faxNumber: '+49 2571 56989 30',
          legalName: 'Moluna GmbH',
          logo: 'https://www.moluna.de/includes/templates/stirling_grand/images/Moluna-Logo.png',
          taxID: '327/5886/7602',
          telephone: '+49 2571 56989 33',
          vatID: 'DE296281834',
          url: 'https://www.moluna.de',
        },
        availability: this.getAvailability(), //TODO:
      },
    };

    this.injectImages(data);

    this.injectAtributeValue(data, 'brand', 'Marke');
    this.injectAtributeValue(data, 'gtin13', 'EAN');
    this.injectAtributeValue(data.offers, 'gtin13', 'EAN');
    this.injectAtributeValue(data, 'name', 'Titel');
    this.injectAtributeValue(data, 'depth', 'Tiefe', this.replaceComa_Punkt);
    this.injectAtributeValue(data, 'height', 'Hoehe', this.replaceComa_Punkt);
    this.injectAtributeValue(data, 'itemCondition', 'Neu');
    this.injectAtributeValue(data, 'manufacturer', 'Hersteller');
    this.injectAtributeValue(data, 'mpn', 'Hersteller_Artikelnummer');
    this.injectAtributeValue(data, 'releaseDate', 'Erscheinungsdatum');
    this.injectAtributeValue(data, 'weight', 'Breite', this.replaceComa_Punkt);
    if (this.props.body.productsDescription != null)
      data.description = this.props.body.productsDescription;

    data['url'] = this.props.body.link;
    data['sku'] = this.props.body.productsId;

    return (
      <script
        type="application/ld+json"
        dangerouslySetInnerHTML={{ __html: JSON.stringify(data) }}
      />
    );
  }

  replaceComa_Punkt(input: string) {
    return replaceAll(input, ',', '.');
  }

  getAvailability() {
    if (
      +this.props.body.products_quantity > 0 &&
      (+this.props.body.productsDeliveryTime == 0 ||
        +this.props.body.productsDeliveryTime == 996)
    )
      return 'InStock';
    else if (
      +this.props.body.productsDeliveryTime <= 30 ||
      +this.props.body.productsDeliveryTime == 997 ||
      +this.props.body.productsDeliveryTime == 994
    )
      return 'BackOrder';
    else if (+this.props.body.productsDeliveryTime == 998) return 'PreOrder';
    else return 'SoldOut';
  }
}
